import React from "react";
import { Typography, Box } from "@mui/material";
import { isNotNullOrEmptyArray } from "../../globals/utils";
import SimpleHeader from "../../components/SimpleHeader";

const SoilTestReportPrint = ({ report, scores, recFertilizer, t }) => {
  const { nitrogen, phosphorus, potassium } = scores || {};

  const styles = {
    container: {
      padding: "20px",
      width: "210mm", // A4 width
      margin: "0 auto",
      backgroundColor: "white",
      boxSizing: "border-box",
    },
    header: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "24px",
      marginBottom: "15px",
    },
    section: {
      width: "100%",
      textAlign: "left",
      marginBottom: "15px",
    },
    sectionTitle: {
      fontWeight: "bold",
      fontSize: "20px",
      marginBottom: "10px",
    },
    fieldRow: {
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "1.5",
      marginBottom: "5px",
    },
    divider: {
      width: "100%",
      borderTop: "3px dashed black",
      margin: "15px 0",
    },
    footer: {
      textAlign: "center",
      fontSize: "18px",
      fontWeight: "bold",
      marginTop: "10px",
    },
    note: {
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "1.4",
      marginTop: "10px",
    },
  };

  return (
    <div style={{ width: "100%", backgroundColor: "white" }}>
      <SimpleHeader />
      <Box style={styles.container}>
        {/* Report Details */}
        {report && (
          <Box style={styles.section}>
            <Typography style={styles.header}>
              {t("SOIL TEST REPORT")}
            </Typography>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              <Typography style={styles.fieldRow}>
                {t("ID")}: {report.id}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Farm")}: {report.farm_land}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Farmer")}: {report.farmer_details?.farmerName || "NA"}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Crop")}: {report.farmer_details?.cropName || "NA"}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Nitrogen")}: {report.nitrogen}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Phosphorus")}: {report.phosphorus}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Potassium")}: {report.potassium}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("pH")}: {report.ph}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("OC")}: {report.organic_carbon}
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Date")}: {(report.report_time || "").split("T")[0]}
              </Typography>
            </div>
          </Box>
        )}

        {/* Scores */}
        {scores && (
          <>
            <div style={styles.divider}></div>
            <Box style={styles.section}>
              <Typography style={styles.sectionTitle}>{t("SCORES")}</Typography>
              <Typography style={styles.fieldRow}>
                {t("Nitrogen")}: {nitrogen || t("N/A")} / 10
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Phosphorus")}: {phosphorus || t("N/A")} / 10
              </Typography>
              <Typography style={styles.fieldRow}>
                {t("Potassium")}: {potassium || t("N/A")} / 10
              </Typography>
            </Box>
          </>
        )}

        {/* Fertilizer Recommendations */}
        {isNotNullOrEmptyArray(recFertilizer) && (
          <>
            <div style={styles.divider}></div>
            <Box style={styles.section}>
              <Typography style={styles.sectionTitle}>
                {t("RECOMMENDATIONS")}
              </Typography>
              {recFertilizer.map((item, index) => (
                <Typography style={styles.fieldRow} key={index}>
                  {`${index + 1}. ${item.fertilizer_name}: ${item.quantity} ${
                    item.unit
                  }`}
                </Typography>
              ))}
              <Typography style={styles.note}>
                {t("Note")}:{" "}
                {t(
                  "Recommended fertilizers are based on the soil test results. Please consult a local agronomist for specific recommendations."
                )}
              </Typography>
            </Box>
          </>
        )}

        <div style={styles.divider}></div>
        <Typography style={styles.footer}>{t("Thank you")}</Typography>
      </Box>
    </div>
  );
};

export default SoilTestReportPrint;
